export default "__VITE_ASSET__CbbdFwwz__"